import Badge from 'react-bootstrap/Badge';
import { FormTextInput } from 'Components/Forms/FormInput.js';
import { Row, Card, Col, Form, Button } from "react-bootstrap";
import { http } from "Utils/http";
import { useEffect, useReducer, useState, useRef } from "react";

import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import Stack from 'react-bootstrap/Stack';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { getEditOrgData, loadFormInfo, submitCreateOrganizationData, submitEditOrganizationData } from 'Components/Datatable/OrgAxiosFuncs'
import { ACTIONS, formInfoReducer } from 'Containers/Private/Organization/OrganizationFormDataReducer'
import { EDIT_ORG_FORM_DISPLAY_DATA } from 'Containers/Private/Organization/Edit/EditOrganizationFormData';
import { Link } from 'react-router-dom';
import { TextButton } from 'Components/Button';
import { STATUSES, ERROR_MESSAGES } from "Utils/constants";
import { useDispatch } from "react-redux"
import { setStatus, setPopup, setRedirect } from "../../../../Store/ErrorInfoSlice";
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import { applyDateSelectorFormat, isDateEmpty } from "Utils/utilityFunctions";


const nameConverter = {
    "orgName": "orgName",
    "psoId": "orgId",
    "orgURL": "orgURL",
    "orgAddrLine1": "orgAddr1",
    "orgAddrLine2": "orgAddr2",
    "orgCity": "orgCity",
    "orgStateCode": "orgState",
    "orgZip": "orgZip",
    "orgZipExt": "orgZipExt",
    "orgPhone": "orgPhone",
    "orgPhoneExtension": "orgPhoneExt",
    "orgFax": "orgFax",
    "organizationStatusId": "orgStatus",
    "scpEnroll": "orgIsSCPEnrolled",
    "scpEnrollDate": "orgSCPEnrollDate",
    "testOrg": "orgIsTest",

    "agreementEffectiveDate": "agreementEffectiveDate",
    "listingDate": "listingEffectiveDate",
    "agreementEndDate": "agreementEndDate",
    "listingEndDate": "listingEndDate",
    "password": "password"

}




function EditOrganization () {
    let location = useLocation();
    const navigate = useNavigate();
    var passedData = location.state;
    //console.log("PASSED DATA");
    //console.log(passedData);
    let { oT } = useParams();
    const dispatch = useDispatch();
    //const dispatch = useDispatch();
    function getOrgTypeText (oType) {
        switch (oType.toLowerCase()) {
            case "PSO".toLowerCase():
                return "PSO";

            case "Admin".toLowerCase():
                return "Admin";

            case "Vendor".toLowerCase():
                return "Vendor";
        }
    }
    const orgType = passedData.orgType; //getOrgTypeText(oT);
    const [additionalOrganizationInfo, setAdditionalOrganizationInfo] = useState(null);


    const initialState = {
        data: '',
        loading: true,
        error: null,
    };
    const [formInfo, formInfoDispatch] = useReducer(formInfoReducer, initialState);


    //const formFieldDisplay = EDIT_ORG_FORM_DISPLAY_DATA(orgType);

    const formFieldDisplay = {
        orgName: {
            type: 'text',
            id: 'orgName',
            name: 'orgName',
            display: {
                label: 'Organization Name',
                description: 'Organization name maximum length: 80',
                title: "Enter an Organization's Name. Maximum number of characters allow for this field is 80 characters.",
                placeholder: null,
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
            /*function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return true;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgId: {
            type: 'text',
            id: 'orgId',
            name: 'orgId',
            display: {
                label: 'Organization ID',
                description: function () {
                    if (orgType.toLowerCase() == "PSO".toLowerCase()) {
                        return "Letter 'P' followed by four numeric digit (i.e, P0000)";
                    }
                    else if (orgType.toLowerCase() == "Vendor".toLowerCase()) {
                        return "Letter 'V' followed by four numeric digit (i.e, V0000)";
                    }
                    else {
                        return null;
                    }
                },
                title: "Enter Organization's ID. Example of a PSO ID: P0001 and Example of a Vendor ID: V0000",
                placeholder: null,
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
            /*hideFieldOrgTypes: function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return true;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgURL: {
            type: 'text',
            id: 'orgURL',
            name: 'orgURL',
            display: {
                label: 'Organization Website URL',
                description: null,
                title: "Enter Organization's website URL",
                placeholder: null,
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null) /*function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return true;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgAddr1: {
            type: 'text',
            id: 'orgAddr1',
            name: 'orgAddr1',
            display: {
                label: 'Address Line 1',
                description: "",
                title: "Enter Street Address",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)/*function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return true;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgAddr2: {
            type: 'text',
            id: 'orgAddr2',
            name: 'orgAddr2',
            display: {
                label: 'Address Line 2',
                description: "",
                title: "Enter Street Address. This field can be used to enter extra street address",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)/*function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return true;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgCity: {
            type: 'text',
            id: 'orgCity',
            name: 'orgCity',
            display: {
                label: 'City',
                description: "",
                title: "Enter City name",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)/*function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return true;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgState: {
            type: 'select',
            id: 'orgState',
            name: 'orgState',
            display: {
                label: 'State',
                description: "",
                title: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)/*function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return true;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgZip: {
            type: 'text',
            id: 'orgZip',
            name: 'orgZip',
            display: {
                label: 'Zip Code',
                description: "",
                title: "Enter Zip code as 5 digits.",
                placeholder: ""
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)/*function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return true;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgZipExt: {
            type: 'text',
            id: 'orgZipExt',
            name: 'orgZipExt',
            display: {
                label: 'Zip Extension',
                description: "",
                title: "Enter 4 digits Zip extension if any",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)/*function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return true;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgPhone: {
            type: 'tel',
            id: 'orgPhone',
            name: 'orgPhone',
            display: {
                label: 'Phone Number',
                description: "(###) ###-####",
                title: "Enter Phone Number as 10 digits. Example: (123) 456-7890",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)/*function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return true;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgPhoneExt: {
            type: 'text',
            id: 'orgPhoneExt',
            name: 'orgPhoneExt',
            display: {
                label: 'Phone Number Extension',
                description: "(i.e 1234)",
                title: "Enter Phone Number extension if any. Example: 1234",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)/*function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return true;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgFax: {
            type: 'tel',
            id: 'orgFax',
            name: 'orgFax',
            display: {
                label: 'Fax Number',
                description: "(###) ###-####",
                title: "Enter Fax Number as 10 digits. Example: (123) 456-7890",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)/*function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return true;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgStatus: {
            type: 'radio',
            id: 'orgStatus',
            name: 'orgStatus',
            display: {
                label: 'Status',
                description: ""
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)/*function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return true;
                        break;
                    default:
                        return false;
                }
            }*/

        },
        orgIsSCPEnrolled: {
            type: 'radio',
            name: 'orgIsSCPEnrolled',
            display: {
                label: 'Enrolled in SCP',
                description: ""
            },
            hideFieldOrgTypes: ["pso", "admin"],
            InputRef: useRef(null)/*function () {
                switch(orgType) {
                    case "PSO":
                        return false;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return false;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgSCPEnrollDate: {
            type: 'date',
            id: 'orgSCPEnrollDate',
            name: 'orgSCPEnrollDate',
            display: {
                label: 'SCP Enrollment Date',
                description: "",
                title: "Enter two digits for Month, two digits for Date and four digits for year"
            },
            hideFieldOrgTypes: ["pso", "admin"],
            InputRef: useRef(null)/*function () {
                switch(orgType) {
                    case "PSO":
                        return false;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return false;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        orgIsTest: {
            type: 'radio',
            name: 'orgIsTest',
            display: {
                label: 'Test Organization',
                description: ""
            },
            hideFieldOrgTypes: ["admin"],
            InputRef: useRef(null)/*function () {
                switch(orgType) {
                    case "PSO":
                        return true;
                        break;
                    case "Vendor":
                        return true;
                        break;
                    case "Admin":
                        return false;
                        break;
                    default:
                        return false;
                }
            }*/
        },
        /*orgListingDate: {
            type: 'date',
            id: 'orgListingDate',
            name: 'orgListingDate',
            display: {
                label: 'Listing Date',
                description: "(MM/DD/YYYY)",
                title: "",
                //placeholder: "MM/DD/YYYY",
            },
            hideFieldOrgTypes: ["vendor","admin"]
                
        },*/

        agreementEffectiveDate: {
            type: 'date',
            id: 'agreementEffectiveDate',
            name: 'agreementEffectiveDate',
            display: {
                label: 'Effective Date',
                description: "",
                title: "",
                //placeholder: "MM/DD/YYYY",
            },
            hideFieldOrgTypes: ["vendor", "admin"],
            InputRef: useRef(null)
        },
        listingEffectiveDate: {
            type: 'date',
            id: 'listingEffectiveDate',
            name: 'listingEffectiveDate',
            display: {
                label: 'Listing Date',
                description: "",
                title: "",
                //placeholder: "MM/DD/YYYY",
            },
            hideFieldOrgTypes: ["vendor", "admin"],
            InputRef: useRef(null)
        },
        agreementEndDate: {
            type: 'date',
            id: 'agreementEndDate',
            name: 'agreementEndDate',
            display: {
                label: 'End Date',
                description: "",
                title: "",
                //placeholder: "MM/DD/YYYY",
            },
            hideFieldOrgTypes: ["vendor", "admin"],
            InputRef: useRef(null)
        },
        listingEndDate: {
            type: 'date',
            id: 'listingEndDate',
            name: 'listingEndDate',
            display: {
                label: 'De-listing Date',
                description: "",
                title: "",
                //placeholder: "MM/DD/YYYY",
            },
            hideFieldOrgTypes: ["vendor", "admin"],
            InputRef: useRef(null)
        },
        password: {
            type: 'password',
            id: 'password',
            name: 'password',
            display: {
                label: 'Password',
                description: '',
                title: "",
                placeholder: null,
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        }


    }
    //console.log(formFieldDisplay);

    var orgStatusValues = (orgStatuses, selectedValue) => {
        var objArr = [];

        if (orgStatuses != null) {
            for (var i = 0; i < orgStatuses.length; i++) {
                var x = orgStatuses[i];
                objArr.push({
                    id: "orgStatus_" + i,
                    label: x.description,
                    name: "orgStatus",
                    value: x.id,
                    title: "Select status as " + x.description,
                    isChecked: selectedValue == x.id ? true : false,
                    onChange: handleRadioChange,
                    disabled: false
                });
            }
        }
        //console.log(objArr);
        return objArr;
    };





    var stateListValues = (stateList, selectedValue) => {
        //console.log(stateList);
        //console.log(selectedValue);
        var objArr = [];
        objArr.push({
            index: 0,
            value: null,
            title: null,
            displayValue: "Select State",
            isSelected: selectedValue == null ? true : false
        });

        for (var i = 0; i < stateList.length; i++) {
            var x = stateList[i];
            objArr.push({
                index: x.regionId,
                value: x.regionId,
                title: "Select state " + x.name,
                displayValue: x.name,
                isSelected: selectedValue == x.regionId ? true : false
            });
        }

        return objArr;
    };

    /*const handleInputTextChange = (e) => {
        //console.log("print out the text input change", e, e.target.attributes.id, e.target.value);
        //console.log(e);
        formInfoDispatch({
          type: ACTIONS.TEXT_CHANGE,
          value: e.target.value,
          name: e.target.name
        });
    }*/

    const handleInputTextChange = (e, pattern) => {
        //console.log("print out the text input change", e, e.target.attributes.id, e.target.value);
        //console.log(e);
        if (pattern != null) {
            var emptyP = /^$/g;
            if (e.target.value.match(pattern) || e.target.value.match(emptyP)) {
                formInfoDispatch({
                    type: ACTIONS.TEXT_CHANGE,
                    value: e.target.value,
                    name: e.target.name
                });
            }
        }
        else {
            formInfoDispatch({
                type: ACTIONS.TEXT_CHANGE,
                value: e.target.value,
                name: e.target.name
            });

        }

    }

    const handleSelectChange = (e) => {
        //console.log("print out select change", e);
        formInfoDispatch({
            type: ACTIONS.SELECT_CHANGE,
            value: e.target.value,
            name: e.target.name
        })
    }

    const handleRadioChange = (e) => {
        //console.log("print out radio change", e);
        //console.log(e.target.id);
        formInfoDispatch({
            type: ACTIONS.RADIO_CHANGE,
            value: e.target.value,
            name: e.target.name
        })
    }

    const handleCheckChange = (e) => {
        //console.log("print out checkbox change", e);
        //console.log(e.target.id);
        formInfoDispatch({
            type: ACTIONS.CHECK_CHANGE,
            name: e.target.name,
            isChecked: e.target.checked
        })
    }

    const handleInputTelChange = (value, data, event, formattedValue) => {

        //console.log("print out the tel input change", value);
        //console.log(value);
        //console.log(data);
        //console.log(event);
        //console.log(formattedValue);
        formInfoDispatch({
            type: ACTIONS.TEXT_CHANGE,
            value: formattedValue,
            name: event.target.id
        });
    }

    const handleInputDateChange = (e) => {
        //console.log("print out the date input change", e, e.target.attributes.id, e.target.value);
        //console.log(e);

        isDateEmpty(e);
        var val = e.target.value;
        //console.log(val);
        if (val != null) {
            var split = val.split("-");
            if (split[0].length > 4) {
                formInfoDispatch({
                    type: ACTIONS.DATE_CHANGE,
                    value: (val.substring(val.length - 7, val.length)).padStart(10, "0"),
                    name: e.target.name
                });
            }
            else {
                formInfoDispatch({
                    type: ACTIONS.DATE_CHANGE,
                    value: val,
                    name: e.target.name
                });
            }
        }
        else {
            formInfoDispatch({
                type: ACTIONS.DATE_CHANGE,
                value: '',
                name: e.target.name
            });
        }
    }

    useEffect(() => {
        //loadFormInfo(orgType, ACTIONS, formInfoDispatch, handleSelectChange, handleInputTextChange, handleRadioChange, handleCheckChange, {stateListValues, orgStatusValues, prefixListValues, suffixListValues});

        getEditOrgData(passedData, ACTIONS, formInfoDispatch, handleSelectChange, handleInputTextChange, handleInputDateChange, handleRadioChange, handleCheckChange, handleInputTelChange, { stateListValues, orgStatusValues })
            .then((res) => {
                if (res !== null && res !== undefined) {
                    //console.log(res);
                    var statusCode = res.status;
                    switch (statusCode.code) {
                        case STATUSES.ERROR.code:
                            break;
                        case STATUSES.SUCCESS.code:
                            setAdditionalOrganizationInfo(res.data);
                            /*navigate(
                                "/manage",
                                { 
                                    state: 
                                    { 
                                        orgType: orgType, 
                                        status: STATUSES.SUCCESS, 
                                        modal: 
                                        {
                                            title: "Success!",
                                            msg: "Organization has been sucessfully updated."
                                        } 
                                    } 
                                }
                            );*/
                            //console.log("SUCEES");
                            break;

                    }
                }
                //console.log(res);
            })
    }, []);






    function getFieldValue (fieldName, data) {
        var values = data[fieldName];
        var dispValues = formFieldDisplay[fieldName];

        //console.log(values);
        if (formInfo.loading) {
            return '';
        }
        else {
            var type = dispValues.type;
            switch (type) {
                case "text":
                    if (values.value != null) {
                        return values.value;
                    }
                    return "";
                case "password":
                    if (values.value != null) {
                        return values.value;
                    }
                    return "";
                case "date":
                    if (values.value != null) {
                        var split = values.value.split('-');
                        //console.log(split);
                        if (split.length == 3) {
                            return split[1] + '/' + split[2] + '/' + split[0];
                        }
                        return values.value;
                    }
                    return "";
                case "select":
                    if (values != null) {
                        var arr = values.options;
                        //console.log("ARR");
                        //console.log(arr);
                        for (var x = 0; x < arr.length; x++) {
                            var val = arr[x];
                            if (val.isSelected) {
                                return val.value;
                            }
                        }
                    }
                    return null;
                case "radio":
                    if (values != null) {
                        var arr = values.radioButtons;
                        for (var x = 0; x < arr.length; x++) {
                            if (arr[x].isChecked) {
                                return arr[x].value;
                            }
                        }
                    }
                    return null;
                case "checkbox":
                    if (values != null) {
                        var arr = values.checkBoxes;
                        for (var x = 0; x < arr.length; x++) {
                            if (arr[x].isChecked) {
                                return arr[x].value;
                            }
                        }
                    }
                    return "";
                case "tel":
                    if (values.value != null) {
                        return values.value;
                    }
                    return "";
                default:
                    return "";
            }
        }

    }






    function addErrorMessages (fieldName, errorFieldName, data) {
        var d = data.fieldErrors;
        var values = d[errorFieldName];
        //console.log(values);

        if (values != null) {
            var field = formFieldDisplay[fieldName];
            var type = field.type;
            var err = values.errorMessages;

            //console.log(err);

            switch (type) {
                case "text":
                    formInfoDispatch({
                        type: ACTIONS.TEXT_SET_ERRORS,
                        name: fieldName,
                        errors: err
                    })
                    break;
                case "password":
                    formInfoDispatch({
                        type: ACTIONS.TEXT_SET_ERRORS,
                        name: fieldName,
                        errors: err
                    })
                    break;
                case "date":
                    formInfoDispatch({
                        type: ACTIONS.DATE_SET_ERRORS,
                        name: fieldName,
                        errors: err
                    })
                    break;
                case "select":
                    formInfoDispatch({
                        type: ACTIONS.SELECT_SET_ERRORS,
                        name: fieldName,
                        errors: err
                    })
                    break;
                case "radio":
                    formInfoDispatch({
                        type: ACTIONS.RADIO_SET_ERRORS,
                        name: fieldName,
                        errors: err
                    })
                    break;
                case "checkbox":
                    formInfoDispatch({
                        type: ACTIONS.CHECK_SET_ERRORS,
                        name: fieldName,
                        errors: err
                    })
                    break;
                case "tel":
                    formInfoDispatch({
                        type: ACTIONS.TEXT_SET_ERRORS,
                        name: fieldName,
                        errors: err
                    })
                    break;
            }

        }
    }

    function clearErrorMessages (data) {
        for (const [key, value] of Object.entries(data)) {
            var t = formFieldDisplay[key];
            var fieldName = key;
            switch (t.type) {
                case "text":
                    formInfoDispatch({
                        type: ACTIONS.TEXT_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "password":
                    formInfoDispatch({
                        type: ACTIONS.TEXT_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "date":
                    formInfoDispatch({
                        type: ACTIONS.DATE_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "select":
                    formInfoDispatch({
                        type: ACTIONS.SELECT_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "radio":
                    formInfoDispatch({
                        type: ACTIONS.RADIO_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "checkbox":
                    formInfoDispatch({
                        type: ACTIONS.CHECK_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
            }

        }
    }

    const handleSubmit = async () => {
        var result = await submitEditOrganizationData(passedData, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue, additionalOrganizationInfo)
            .then((res) => {
                if (res !== null && res !== undefined) {
                    //console.log(res);
                    var statusCode = res.data.status;
                    if (statusCode != 1) {

                    }
                    else {
                        setGlobalSuccessStatus({
                            dispatch: dispatch,
                            popupData: {
                                visible: true,
                                title: "Success!",
                                msg: "Organization has been sucessfully updated.",
                                showContactHelp: false
                            },
                            redirect: {
                                redirect: true,
                                redirectFirst: true,
                                path: "/manage/organization",
                                data: { state: { orgType: orgType } }
                            }
                        });
                    }
                }
                //console.log(res);
            }).catch((error) => {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: false
                    },
                    redirect: {
                        redirect: true,
                        redirectFirst: false,
                        path: "/manage/organization",
                        data: { state: { orgType: orgType } }
                    },
                    error: error
                });
            })
        //submitCreateOrganizationData(orgType, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue);

    };

    const handleCancel = async () => {
        navigate(
            "/manage/organization",
            { state: { orgType: orgType } }
        );
        //clearErrorMessages(formInfo.data);
    };


    var dispErrors = (fieldName) => {
        var data = formInfo.data[fieldName];
        var dispData = formFieldDisplay[fieldName];
        return (
            <div>
                {data.validation.errors.length > 0 ? data.validation.errors.map((errorText, index) =>
                    <Stack key={dispData.name + "Errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                        <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                        <div>{errorText}</div>
                    </Stack>

                ) : null}
            </div>
        );
    }

    var dispLabel = (fieldName, isHidden, getColLabelSizes, alignment, multi) => {
        var data = formInfo.data[fieldName];
        var dispData = formFieldDisplay[fieldName];

        if (alignment == Row) {
            if (multi == true) {
                return (
                    <Col hidden={isHidden}
                        xs={getColLabelSizes('xs')}
                        sm={getColLabelSizes('sm')}
                        md={getColLabelSizes('md')}
                        lg={getColLabelSizes('lg')}
                        xl={getColLabelSizes('xl')}
                        xxl={getColLabelSizes('xxl')}
                    >
                        <legend>
                            {<span className="me-2">{dispData.display.label}</span>}
                            {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
                        </legend>
                    </Col>
                );
            }
            else {
                return (
                    <Form.Label visuallyHidden={isHidden} column
                        xs={getColLabelSizes('xs')}
                        sm={getColLabelSizes('sm')}
                        md={getColLabelSizes('md')}
                        lg={getColLabelSizes('lg')}
                        xl={getColLabelSizes('xl')}
                        xxl={getColLabelSizes('xxl')}
                    >
                        {<span className="me-2">{dispData.display.label}</span>}
                        {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
                    </Form.Label>
                );
            }
        }
        else {
            if (multi == true) {
                return (
                    <Row hidden={isHidden}
                        xs={getColLabelSizes('xs')}
                        sm={getColLabelSizes('sm')}
                        md={getColLabelSizes('md')}
                        lg={getColLabelSizes('lg')}
                        xl={getColLabelSizes('xl')}
                        xxl={getColLabelSizes('xxl')}
                    >
                        <legend>
                            {dispData.display.label}
                            {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
                        </legend>
                    </Row>
                );
            }
            else {
                return (
                    <Form.Label visuallyHidden={isHidden}
                        xs={getColLabelSizes('xs')}
                        sm={getColLabelSizes('sm')}
                        md={getColLabelSizes('md')}
                        lg={getColLabelSizes('lg')}
                        xl={getColLabelSizes('xl')}
                        xxl={getColLabelSizes('xxl')}
                    >
                        {dispData.display.label}
                        {data.validation.required ? '' : /*<span className="optionalField"><br></br>optional</span>*/ <Badge bg="optional">Optional</Badge>}
                    </Form.Label>
                );
            }

        }

    };


    return (
        <Row>
            {
                formInfo.loading ?
                    null
                    :
                    <Row >
                        <Col xl={11} lg={11} md={11} sm={12}>
                            <Card className="p-4">
                                <Card.Body className="text-start">

                                    <Row>
                                        <h1 id="mainContent" className="header1 text-start mb-3 blue bold">{"Edit " + orgType + " Organization"}</h1>
                                        <p>To edit an organization, enter the required information below.</p>
                                    </Row>
                                    <Row>

                                        <Form>

                                            <h2>Organization Information</h2>

                                            <FormTextInput orgType={orgType} fieldName="orgName" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={80}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgId" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={5}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgURL" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={256}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgAddr1" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={75}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgAddr2" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={75}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgCity" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={75}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgState" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgZip" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={5}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgZipExt" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={4}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgPhone" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgPhoneExt" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='5' minLength='1'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgFax" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgStatus" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            {/*<FormTextInput orgType={orgType} fieldName="orgIsSCPEnrolled" hideLabel={false} horizontalForm={{is: true, labelCols: {lg:2}, inputCols: {lg:5}}} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                        <FormTextInput orgType={orgType} fieldName="orgSCPEnrollDate" hideLabel={false} horizontalForm={{is: true, labelCols: {lg:2}, inputCols: {lg:5}}} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='10'></FormTextInput>
                                        */}
                                            <FormTextInput orgType={orgType} fieldName="orgIsTest" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>

                                            {orgType == "PSO" ? <h2>Data Submission and Use Agreement</h2> : null}

                                            <FormTextInput orgType={orgType} fieldName="agreementEffectiveDate" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='10'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="agreementEndDate" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='10'></FormTextInput>

                                            {orgType == "PSO" ? <h2>Listing Date</h2> : null}

                                            <FormTextInput orgType={orgType} fieldName="listingEffectiveDate" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='10'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="listingEndDate" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='10'></FormTextInput>


                                            <h2>Authorize and Update changes</h2>
                                            <FormTextInput orgType={orgType} fieldName="password" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 2 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} ></FormTextInput>


                                            {
                                                /*
                                                <div class="row" style="font-weight:normal;">
                                                    <h2 tabindex="0" tabindex="0" style="color: black; border-bottom: 1px solid black; border-top: none; margin:25px 0px 15px 0px;">Authorize and Update changes</h2>
                                                    <p tabindex="0"><label for="passwordSubmit">Enter your password and submit to update this form.&nbsp;<span class="redtext">*</label></p>
                                                    <div class="w400" style="font-weight:normal;">
                                                        <c:if test="${errors.password != null}">
                                                            <span tabindex="0" class="msg-error-field"><spring:message code="${errors.password}" arguments="Password"/></span>
                                                        </c:if>
                                                        <label style="display:inline">
                                                        <input tabindex="0" title="Enter your password and submit to update this form" type="password" name="password" id="passwordSubmit" size="50" class="medium" aria-required="true"></input>
                                                        &nbsp;&nbsp;<a href="" title="Click to show or hide password" id="pswd_toggle" onClick="toggleField('passwordSubmit','pswd_toggle'); return false;" style="font-weight: normal;">Show Password</a>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="clear"></div>
                                                
                                                
                                                <div class="row right" id="actionButton">
                                                    <input type="hidden" name="organizationId" value="${organizationDetails.organizationId}" />
                                                    <input type="submit" title="Click on Submit to edit an organization" tabindex="0" name="submit" value="Submit " style="width:auto; padding: 9px 8px 7px 8px;" />
                                                    <!--<a tabindex="0" href="${context}/manage/${orgType}" title="Click on Cancel to go back to the Manage Organization page" class="silverButton">Cancel</a>-->
                                                    <input  tabindex="0" title="Click on Cancel to go back to the Manage ${orgType} Organization page" type="button" name="cancel" value="Cancel" class="cancel" onclick="window.location='${context}/manage/${orgType}'; return false;" />
                                                </div>
                                                */
                                            }

                                            <Stack className="pt-3" direction="horizontal" gap={3}>
                                                {/* Submit Button */}
                                                <TextButton
                                                    variant="normal"
                                                    onClick={handleSubmit}
                                                    content={"Submit"}
                                                >
                                                </TextButton>

                                                {/* Cancel Button */}
                                                <TextButton
                                                    variant="outline"
                                                    onClick={handleCancel}
                                                    content={"Cancel"}
                                                >
                                                </TextButton>
                                            </Stack>




                                        </Form>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
            }
        </Row>
    );
}



export default EditOrganization;